define([
  'is-hotkey',
  'es6!sumo/slate/util/constants'
], (
  { isMac },
  SlateConstants
) => {
  const haveBlocks = (value, type) => {
    return value && value.blocks.some(node =>
      node.type === type || node.type.indexOf(`${type}`) === 0);
  };

  const hasBlock = (value, type) => {
    return value.blocks.some(node => node.type === type);
  };

  const getBlock = (value, type) => {
    return value.blocks.filter(node => node.type === type).first();
  };

  const getBlockType = (value) => {
    return value.blocks.first().type;
  };

  const getBlockData = (value) => {
    if (value.blocks.size === 0) return {};
    return value.blocks.first().data.toJS();
  };

  const getHotkey = (hotkey) => {
    if (isMac) {
      return hotkey
        .replace('mod+shift','⇧⌘')
        .replace('mod+ctrl','⌃⌘')
        .replace('mod+alt','⌥⌘')
        .replace('mod','⌘')
        .replace('ctrl','⌃')
        .replace('alt','⌥')
        .replace('shift','⇧')
        .replace('+','')
        .toUpperCase()
      ;
    } else {
      const keys = hotkey.split('+');
      keys.forEach((key, idx) => {
        if (key.length === 1) keys[idx] = key.toUpperCase();
        if (key === 'mod') keys[idx] = 'ctrl';
      })
      return keys.join('+');
    }
  };

  const getKeyPathsMatching = (root, predicate, results = { keyPath: [], keyPaths: [] }) => {
    let topNodes;

    if (nodeMatchesPredicate(root, predicate)) {
      results.keyPaths.push(results.keyPath.slice());
    }

    if (root.has('document')) {
      topNodes = root.getIn(['document', 'nodes']);
      results.keyPath.push('document');
      results.keyPath.push('nodes');
    } else if (root.has('nodes')) {
      topNodes = root.get('nodes');
      results.keyPath.push('nodes');
    } else if (root.has('leaves')) {
      topNodes = root.get('leaves');
      results.keyPath.push('leaves');
    }

    if (topNodes) {
      topNodes.forEach((node, index) => {
        results.keyPath.push(index);
        getKeyPathsMatching(node, predicate, results);
        results.keyPath.splice(-1);
      });

      results.keyPath.splice(-1);
    }

    return results.keyPaths;
  };

  const isVoidBlock = (editor) => {
    console.log("editor");
    console.log(editor);
    return editor && editor.value && editor.value.blocks.some(node => editor.isVoid(node));
  };

  const haveInlines = (value, type) => {
    return value && value.inlines.some(node =>
      node.type === type || node.type.indexOf(`${type}`) === 0);
  };

  const haveMarks = (value, type) => {
    return value && value.marks.some(mark => mark.type === type);
  };

  const hasMark = (value, type) => {
    return value && value.activeMarks.some(mark => mark.type == type);
  };

  const getMark = (value, type) => {
    return value && value.marks.filter(mark => mark.type === type).first();
  };

  const getMarkData = (value) => {
    if (value.marks.size === 0) return {};
    return value.marks.first().data.toJS();
  };

  const nodeMatchesPredicate = (node, predicate) => (
    Object.keys(predicate).reduce((matches, predicateKey) => (
      matches && node.get(predicateKey) === predicate[predicateKey]
    ), true)
  );

  const tryParseJSON = (json) => {
    if (!json) return null;
    if (typeof json === 'object' && json.document) {
      return json;
    }
    try {
      const o = JSON.parse(json);
      if (o && typeof o === 'object' && o.document) {
        return o;
      }
    }
    catch (e) { }
    return null;
  };

  const getBlockTypeFromTagName = (tagName) => {
    return  SlateConstants.blockTags[tagName] 
            || SlateConstants.inlineTags[tagName] 
            || SlateConstants.markTags[tagName];
  };

  const getObjectTypeFromTagName = (tagName) => {
    if (SlateConstants.blockTags[tagName]) return 'block';
    if (SlateConstants.inlineTags[tagName]) return 'inline';
    if (SlateConstants.markTags[tagName]) return 'mark';
  };

  return {
    haveBlocks,
    hasBlock,
    getBlock,
    getBlockType,
    getBlockTypeFromTagName,
    getObjectTypeFromTagName,
    getBlockData,
    getHotkey,
    getKeyPathsMatching,
    isVoidBlock,
    haveInlines,
    haveMarks,
    hasMark,
    getMark,
    getMarkData,
    tryParseJSON,
  };
});
